import { ColorGrid } from '@laranda/lib-sysutil';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { registerLocaleData, DatePipe, CommonModule } from '@angular/common';
import localeEsVe from '@angular/common/locales/es-VE';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from '../app/core/core.module';
import { AppComponent } from './app.component';



// Rutas
import { AppRoutingModule } from './app-routing.module';
import { DataTablesModule } from 'angular-datatables';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


registerLocaleData(localeEsVe, 'es-VE');

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    DataTablesModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    CoreModule,
    NgbModule,
    // FontAwesomeModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-VE' },
    DatePipe,
    ColorGrid
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


